export const interactionsEnTranslations = {
  // Wizard selection page
  interactionWizards: 'Interaction Wizards',
  wizardsDescription:
    "Choose the type of workplace conversation you'd like to have. Our wizards will guide you through structured flows to create meaningful I See You and I Need You interactions.",
  praiseWizard: 'I See You Wizard',
  praiseSubtitle: 'Share positive workplace experiences',
  praiseDescription:
    'Recognize great work, celebrate achievements, and strengthen relationships through structured positive feedback. Perfect for highlighting successes and building team morale.',
  recognitionAndAppreciation: 'Recognition and appreciation',
  goalImpactAssessment: 'Goal impact assessment',
  companyValuesAlignment: 'Company values alignment',
  startPraiseWizard: 'Start I See You Wizard',
  feedbackWizard: 'I Need You Wizard',
  feedbackSubtitle: 'Share constructive feedback',
  feedbackDescription:
    'Provide constructive feedback to help colleagues grow and improve. Focus on specific behaviors and their impact to create meaningful development conversations.',
  constructiveDevelopmentFeedback: 'Constructive development feedback',
  stakeholderImpactAssessment: 'Stakeholder impact assessment',
  organizationalImpactAnalysis: 'Organizational impact analysis',
  startFeedbackWizard: 'Start I Need You Wizard',
  wizardsFooter:
    'Choose the wizard that best fits your conversation needs. Each wizard provides a structured approach to workplace communication and feedback.',

  // Interactions table
  iSeeU: 'I See You',
  iNeedU: 'I Need You',
  iLearn: 'I Learn',
  draft: 'Draft',
  sent: 'Sent',
  actionPlan: 'Action Plan',
  finished: 'Finished',
  actionRequired: 'Action required',
  unknown: 'Unknown',
  noData: 'No data',
  loadingInteractions: 'Loading interactions...',
  noInteractionsFound: 'No interactions found',
  tryAdjustingFilters: 'Try adjusting your filters or create a new interaction',
  filters: 'Filters',
  search: 'Search',
  searchByParticipant: 'Search by participant...',
  type: 'Type',
  allTypes: 'All types',
  status: 'Status',
  allStatuses: 'All statuses',
  fromDate: 'From Date',
  toDate: 'To Date',
  pendingFeedbackAlert:
    'You have pending feedback that requires action. Please review and complete them.',
  createdByMe: 'Created by me',
  participatedIn: 'Participated in',
  participant: 'one participant',
  participants: 'Participants',
  date: 'Date',
  goal: 'Goal',
  noGoal: 'No goal',
  reason: 'Reason',
  latestInteractions: 'Latest Interactions',
  latestInteractionsSubtitle:
    'Your recent I See You and I Need You interactions',
};
